import { z } from 'zod';
import { AncillaryCabinSchema } from '../../flight_ancillary/views.js';

const ModalSessionFlightLegEndpointViewSchema = z
  .object({
    iata: z.string().min(1),
    /** Nome do aeroporto — rótulo do nó da linha do tempo. */
    name: z.string().min(1).optional(),
    /** Horário local-naive do gateway; o cliente formata sem converter fuso. */
    at: z.string().min(1).optional(),
  })
  .strict();

/** Uma perna real do itinerário da oferta (voo + a parada que o segue) — projeção
 *  PÚBLICA das pernas que o adapter de voo hidrata. Alimenta a linha do tempo do
 *  drawer "Detalhe do voo" no canal app; display-only, sem chave de busca. */
export const ModalSessionFlightLegViewSchema = z
  .object({
    origin: ModalSessionFlightLegEndpointViewSchema,
    destination: ModalSessionFlightLegEndpointViewSchema,
    durationSeconds: z.number().int().nonnegative().optional(),
    /** Espera até o próximo voo — ausente/zero na última perna. */
    layoverSeconds: z.number().int().nonnegative().optional(),
    /** A perna é uma conexão (troca de aeronave em relação à anterior). */
    isConnection: z.boolean().optional(),
    /** Código IATA da cia da perna — compõe o rótulo "continua no voo AD 2778". */
    carrierCode: z.string().min(1).optional(),
    flightNumber: z.string().min(1).optional(),
    /** Direção num round-trip; ausente em sessão legada ou oferta one-way. */
    direction: z.enum(['outbound', 'return']).optional(),
    /** Cia que OPERA a perna quando difere da que vende (dado do gateway — é o
     *  que vale contratualmente; presente só quando o fornecedor o reporta). */
    operatedBy: z
      .object({ code: z.string().min(1), name: z.string().min(1).optional() })
      .strict()
      .optional(),
    /** Cabine da perna no vocabulário do domínio — o gateway a manda em texto
     *  livre ("Economica", "EXECUTIVE"); ausente quando ele não diz. Escolhe o
     *  mapa de assentos da cabine certa (#5949). */
    cabin: AncillaryCabinSchema.optional(),
  })
  .strict();
export type ModalSessionFlightLegView = z.infer<typeof ModalSessionFlightLegViewSchema>;

export const ModalSessionFlightLegsViewSchema = z
  .object({
    legs: z.array(ModalSessionFlightLegViewSchema).default([]),
  })
  .strict();
export type ModalSessionFlightLegsView = z.infer<typeof ModalSessionFlightLegsViewSchema>;
